module.exports = __webpack_public_path__ + "static/media/2.4a1bba8d.mp3";